module.exports = __webpack_public_path__ + "img/jgtbs.e8b3df36.png";